import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASEURL, BASEURL, CONTENT_BASEURL } from "../../Utils/Constants/constants";



export const getAllScreens = createApi({
  reducerPath: "getAllScreens",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL,
  }),
  tagTypes: ["DigitalSignage"],
  endpoints: (builder) => ({
    getAllScreens: builder.mutation({
      query: (data) => ({
        url: "screen/getScreens.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getSingleScreenDetails: builder.mutation({
      query: (data) => ({
        url: "screen/getSingleScreenDetails.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
   getAllMediaOfCurrentScreen: builder.mutation({
      query: (data) => ({
        url: "association/getPosts.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    chnageScreenName: builder.mutation({
      query: (data) => ({
        url: "screen/renameScreen.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateOrientation: builder.mutation({
      query: (data) => ({
        url: API_BASEURL + "updateOrientation.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateLayout: builder.mutation({
      query: (data) => ({
        url: "screen/updateScreenLayout.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateScreenConfigs: builder.mutation({
      query: (data) => ({
        url: "screen/updateScreenConfiguration.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    deleteLogo: builder.mutation({
      query: (data) => ({
        url: "screen/deleteLogo.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getScreenLayout: builder.mutation({
      query: (data) => ({
        url: "screen/getScreenLayout.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    mainAuth: builder.mutation({
      query: (data) => ({
        url: "customer/signage.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    checkUserNameAvailability: builder.mutation({
      query: (data) => ({
        url: "customer/enquireCustomerID.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    forgetpassword: builder.mutation({
      query: (data) => ({
        url: "customer/forgotPassword.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getUserDetails: builder.mutation({
      query: (data) => ({
        url: "customer/signage.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getAllScreenPosts: builder.mutation({
      query: (data) => ({
        url: "association/getPostsOfScreen.bkp.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addMediatoCloud: builder.mutation({
      query: (data) => ({
        url: "boostboard-content/addMedia.php",
        method: "POST",
        body: data,
        baseUrl: CONTENT_BASEURL
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addFooterLogo: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/addFooterLogo.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addSidebarBgImage: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/addSidebarBgImage.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addMediatoAsOffline: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/updateMediaOfflineStatus.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addMediatoAsOfflineGroup: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/updateGroupMediaOfflineStatus.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateMediaLive: builder.mutation({
      query: (data) => ({
        url: "media/updateLive.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getLayoutImages: builder.mutation({
      query: (data) => ({
        url: "layouts/getLayouts.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getSidebarContent: builder.mutation({
      query: (data) => ({
        url: "association/getSidebarContent.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    addSidebarContent: builder.mutation({
      query: (data) => ({
        url: "association/createSidebarContent.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateSidebarContent: builder.mutation({
      query: (data) => ({
        url: "screen/updateSidebarContent.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    deleteSidebarContent: builder.mutation({
      query: (data) => ({
        url: "association/deleteSidebarContent.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getDuration: builder.mutation({
      query: (data) => ({
        url: "association/getDuration.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getMedia: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/getMedia.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    createPost: builder.mutation({
      query: (data) => ({
        url: "association/createPost.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),

    createPostForSingleScreen: builder.mutation({
      query: (data) => ({
        url: "association/createPost.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updatePost: builder.mutation({
      query: (data) => ({
        url: "association/updatePost.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    changePostOrder: builder.mutation({
      query: (data) => ({
        url: "association/changePostOrderScreenWise.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    changeMediaOrder: builder.mutation({
      query: (data) => ({
        url: "association/changePostOrderScreenWise.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateMediaDuration: builder.mutation({
      query: (data) => ({
        url: "association/updateImageDuration.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    unlinkScreen: builder.mutation({
      query: (data) => ({
        url: API_BASEURL + "disconnectScreen.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    deletePost: builder.mutation({
      query: (data) => ({
        url: "association/deletePost.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    deleteMedia: builder.mutation({
      query: (data) => ({
        url: "association/deleteAssociation.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateCustomization: builder.mutation({
      query: (data) => ({
        url: "customization/updateCustomizationBkp.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getDashboardStats: builder.mutation({
      query: (data) => ({
        url: "analytics/getDashboardStats.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateScreenWisePostStatus: builder.mutation({
      query: (data) => ({
        url: "association/updateScreenWisePostStatus.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updatePostStatusInScreen: builder.mutation({
      query: (data) => ({
        url: "association/changePostStatusInScreen.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateSidebarContentStatus: builder.mutation({
      query: (data) => ({
        url: "association/changeSidebarContentStatus.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateScreenFooterOption: builder.mutation({
      query: (data) => ({
        url: "association/updateScreenFooterOption.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),

    updatePostScheduling: builder.mutation({
      query: (data) => ({
        url: "association/updateScheduling.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateSidebarScheduling: builder.mutation({
      query: (data) => ({
        url: "association/updateSidebarScheduling.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    updateMediaScheduling: builder.mutation({
      query: (data) => ({
        url: "association/updateScheduling.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getlogbandwidth: builder.mutation({
      query: (data) => ({
        url: "log/get_log_bandwidth.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getpinglog: builder.mutation({
      query: (data) => ({
        url: "log/get_log_ping.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    enquiremedia: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/enquireMedia.php",
        method: "POST",
        body: data,
        baseUrl: CONTENT_BASEURL
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    deletemedia: builder.mutation({
      query: (data) => ({
        url: CONTENT_BASEURL + "boostboard-content/deleteMedia.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getCountries: builder.mutation({
      query: (data) => ({
        url: "location/searchLocations.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getWeather: builder.mutation({
      query: (data) => ({
        url: API_BASEURL + "getWeather.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    refreshScreen: builder.mutation({
      query: (data) => ({
        url: API_BASEURL + "restartApplication.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    logout: builder.mutation({
      query: (data) => ({
        url: "customer/logoutCustomer.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getNews: builder.query({
      query: () => ({
        url: "news/getAllNews.php",
        method: "POST",
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getSelectiveNews: builder.mutation({
      query: (data) => ({
        url: "news/getFooterData.php",
        method: "POST",
        body: data
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getRSSNews: builder.mutation({
      query: (data) => ({
        url: "news/new/getFooterRssNews.php",
        method: "POST",
        body: data
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    sumitfeedback: builder.mutation({
      query: (data) => ({
        url: "feedback/addFeedback.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getAllScreensforTTS: builder.mutation({
      query: (data) => ({
        url: "screen/getScreensforTTS.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getNewsFromSources: builder.mutation({
      query: (data) => ({
        url: "dynamic_iframes/dynamic_news.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
     // Modify By RS
      createGroup: builder.mutation({
      query: (data) => ({
        url: "group/group.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      createGroupPost: builder.mutation({
      query: (data) => ({
        url: "association/createGroupPost.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      getGroupPost: builder.mutation({
      query: (data) => ({
        url: "association/getGroupPosts.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      getScreenConfigs: builder.mutation({
      query: (data) => ({
        url: "screen/getConfigsData.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      deleteGroupPost: builder.mutation({
      query: (data) => ({
        url: "association/deleteAssociationInGroup.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      changeGroupPostorder: builder.mutation({
      query: (data) => ({
        url: "association/changePostOrderGroupWise.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      changeGroupPoststatus: builder.mutation({
      query: (data) => ({
        url: "association/changePostStatusInGroup.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      changeGroupPostimageduration: builder.mutation({
      query: (data) => ({
        url: "association/updateImageDurationInGroup.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      updateschedullinggroup: builder.mutation({
      query: (data) => ({
        url: "association/updateSchedulingInGroup.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      updategroupfooter: builder.mutation({
      query: (data) => ({
        url: "association/updateGroupFooterOption.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      getAllCountry: builder.mutation({
      query: (data) => ({
        url: "location/getCountry.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
    getStatesByCountry: builder.mutation({
      query: (data) => ({
        url: "location/getStatesByCountry.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
      getscreensforgroup: builder.mutation({
      query: (data) => ({
        url: "screen/getScreensForGroups.php",
        method: "POST",
         body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    }),
  // Modify By RS
    getRSSNewsSources: builder.mutation({
      query: (data) => ({
        url: "rss/convertRssIntoJson.php",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DigitalSignage"],
    })
  }),
 

});

export const {
  useAddMediatoAsOfflineGroupMutation,
  useGetscreensforgroupMutation,
  useUpdategroupfooterMutation,
  useUpdateschedullinggroupMutation,
  useChangeGroupPostimagedurationMutation,
  useChangeGroupPoststatusMutation,
  useChangeGroupPostorderMutation,
  useDeleteGroupPostMutation,
  useGetGroupPostMutation,
  useCreateGroupMutation,
  useCreateGroupPostMutation,
  useGetAllScreensMutation,
  useChnageScreenNameMutation,
  useCheckUserNameAvailabilityMutation,
  useMainAuthMutation,
  useForgetpasswordMutation,
  useGetUserDetailsMutation,
  useGetAllScreenPostsMutation,
  useAddMediatoCloudMutation,
  useAddMediatoAsOfflineMutation,
  useUpdateMediaLiveMutation,
  useGetLayoutImagesMutation,
  useGetDurationMutation,
  useGetMediaMutation,
  useCreatePostMutation,
  useUpdatePostMutation,
  useChangePostOrderMutation,
  useUnlinkScreenMutation,
  useUpdateScreenWisePostStatusMutation,
  useUpdatePostSchedulingMutation,
  useDeletePostMutation,
  useUpdateCustomizationMutation,
  useGetDashboardStatsMutation,
  useGetCountriesMutation,
  useGetWeatherMutation,
  useLogoutMutation,
  useEnquiremediaMutation,
  useDeletemediaMutation,
  useGetlogbandwidthMutation,
  useGetpinglogMutation,
  useRefreshScreenMutation,
  useGetNewsQuery,
  useSumitfeedbackMutation,
  useGetAllScreensforTTSMutation,
  useGetNewsFromSourcesMutation,
  useGetRSSNewsSourcesMutation,
  useGetAllMediaOfCurrentScreenMutation,
  useCreatePostForSingleScreenMutation,
  useUpdatePostStatusInScreenMutation,
  useChangeMediaOrderMutation,
  useUpdateMediaDurationMutation,
  useUpdateMediaSchedulingMutation,
  useDeleteMediaMutation,
  useUpdateScreenFooterOptionMutation,
  useGetSelectiveNewsMutation,
  useGetRSSNewsMutation,
  useUpdateOrientationMutation,
  useUpdateLayoutMutation,
  useGetScreenLayoutMutation,
  useGetSidebarContentMutation,
  useUpdateSidebarContentStatusMutation,
  useUpdateSidebarSchedulingMutation,
  useAddSidebarContentMutation,
  useUpdateSidebarContentMutation,
  useUpdateScreenConfigsMutation,
  useGetScreenConfigsMutation,
  useAddFooterLogoMutation,
  useGetSingleScreenDetailsMutation,
  useGetAllCountryMutation,
  useGetStatesByCountryMutation,
  useAddSidebarBgImageMutation,
  useDeleteSidebarContentMutation,
  useDeleteLogoMutation,
  
} = getAllScreens;
